import { type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ApiClient } from '@sentinel/api-client';
import { FederatedStepUpProvider, type FederatedStepUpMessages } from '@sentinel/auth-core';

export function PortalFederatedStepUpProvider({
  apiClient,
  children,
}: {
  apiClient: ApiClient;
  children?: ReactNode;
}) {
  const { t } = useTranslation('step-up');
  const messages = useMemo<FederatedStepUpMessages>(
    () => ({
      title: t('federated_title'),
      describe: (idp) =>
        idp ? t('federated_description', { idp }) : t('federated_description_generic'),
      confirm: t('federated_continue'),
      cancel: t('federated_cancel'),
      destinationLabel: t('federated_destination_label'),
    }),
    [t],
  );
  return (
    <FederatedStepUpProvider apiClient={apiClient} messages={messages}>
      {children}
    </FederatedStepUpProvider>
  );
}
